import { snack } from "components/Snack/Snack";
import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import duasSAService from "services/superadmin/duasSAService";
import duaCategoriesSAService from "services/superadmin/duaCategoriesSAService";
import { languages } from "globals-variables";

const DuaForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { dua, duaCategories },
}) => {

  const fieldsWithData = [
    {
      key: "name",
      label: "Название",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "description",
      label: "Описание",
      required: true,
      inputType: inputTypeEnum.richText,
    },
    {
      key: "arabicText",
      label: "Арабский текст",
      inputType: inputTypeEnum.richText,
    },
    {
      key: "translation",
      label: "Перевод",
      inputType: inputTypeEnum.richText,
    },
    {
      key: "transcript",
      label: "Транскрипт",
      inputType: inputTypeEnum.richText,
    },
    {
      key: "language",
      label: "Язык",
      inputType: inputTypeEnum.select,
      options: languages.map(l => ({ id: l.key, name: l.label }))
    },
    {
      key: "duaCategoryID",
      label: "Категория",
      inputType: inputTypeEnum.select,
      options: duaCategories.data.map((c) => ({
        id: c.id,
        name: c.name,
      })
      )
    },
    {
      key: "status",
      label: "Статус",
      inputType: inputTypeEnum.checkbox
    },
  ]

  const onSubmit = async (formValues) => {
    try {
      if (dua) {
        await duasSAService.put(id, formValues)
        snack("Дуа обновлен успешно!");
      } else {
        await duasSAService.post(formValues)
        snack("Дуа создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={dua ? 'Редактирование дуа' : 'Создание дуа'}>
      <AppForm onSubmit={onSubmit} data={dua} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(DuaForm, (router) => {
    let requests = {
      duaCategories: () => duaCategoriesSAService.getAll()
    }
    if (router.params.id) {
      requests['dua'] = () => duasSAService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
